import { sslProductReducer } from "app/sslReducer";
import AddToCartButton from "components/AddToCartButton";
import BillingCycleOptions from "components/BillingCycleOptions";
import CardWrapper from "components/CardWrapper";
// import PromoKaosTumbler from "components/promoKaosTumbler";
import {
  addToCart,
  changeProductFromCart,
} from "features/common/layouts/cartSlice";
import {
  getProduct,
  replaceCurrentProducts,
  selectProduct,
} from "features/common/products/productsSlice";
import { formatIDR, useQuery } from "helpers/utils";
import { getProducts } from "features/ssl/sslSlice";
import MainLayouts from "layouts/MainLayouts";
import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { Placeholder, Spinner, Alert, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { setOrderParams } from "features/common/layouts/cartSlice";
import { useLocation } from "react-router-dom";

const sslType = [
  {
    id: 1,
    title: "Domain Validated",
    value: "domain_validated",
    pid_contain: [
      98, 56, 30, 190, 106, 31, 103, 99, 92, 122, 33, 191, 135, 110,
      1237, 1238,
    ],
  },
  {
    id: 2,
    title: "Organization Validated",
    value: "organization_validated",
    pid_contain: [
      93, 94, 362, 138, 136, 91, 97, 386, 387, 137, 388, 180, 389, 181,
      1239, 1240,
    ],
  },
  {
    id: 3,
    title: "Extended Validated (Green Bar)",
    value: "extended_validated",
    pid_contain: [439, 96, 384, 32, 1241],
  },
];

const OrderSSL = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const customfieldRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pid = params.get("pid");
    const billingcycle = params.get("billingcycle");
    dispatch(setOrderParams({ pid, billingcycle }));
  }, [location.search, dispatch]);

  const { products, status } = useSelector((state) => state.ssl);
  const { productsList } = useSelector((state) => state.cart);
  const currentProduct = useSelector(selectProduct);

  const [category, setCategory] = useState({ value: "", sslItem: [] });
  const [termin, setTermin] = useState("annually");
  const [priceByTermin, setPriceByTermin] = useState(0);
  const [customFields, setCustomFields] = useState(false);

  // State dari CustomFieldsInput
  const [webVal, setWebVal] = useState('tanpa www');
  const [approveEmail, setApproveEmail] = useState('admin@yourdomain.xyz');
  const [CSR, setCSR] = useState('');
  const [FQDN, setFQDN] = useState('');
  const [domainValue, setDomainValue] = useState('');
  const [productNotAvailable, setProductNotAvailable] = useState(false);

  const [sslProduct, sslDispatch] = useReducer(sslProductReducer, {
    pid: +query.pid || 98,
    price: {},
    productDetails: null,
    selectedSSL: query.pid ? +query.pid : "none", // Inisialisasi selectedSSL dengan query.pid jika ada
  });

  const { current, status: currentProductStatus } = currentProduct;
  const { pid, productDetails, selectedSSL } = sslProduct;
  
  // Ref untuk track PID yang sudah di-fetch untuk mencegah loop
  const fetchedPidRef = useRef(null);
  // Ref untuk track apakah sudah restore dari cart untuk mencegah loop
  const restoredFromCartRef = useRef(false);
  // Ref untuk track PID yang sudah di-restore
  const restoredPidRef = useRef(null);

  // const [showPromo, setShowPromo] = useState(true);
  // const [promoKaosTumbler, setPromoKaosTumbler] = useState(false);
  // const { total } = useSelector((state) => state.cart);

  // const checkPromoKaosTumbler = () => {
  //   setPromoKaosTumbler(!promoKaosTumbler);
  // };

  const sortedProductSSL = useCallback(
    (checkedPID) => {
      return products.filter((item) => 
        checkedPID.includes(item.pid) && 
        !item.name.toLowerCase().includes('certum')
      );
    },
    [products]
  );

  // Cek apakah PID yang diakses adalah Certum (PID 110 atau produk dengan nama Certum)
  useEffect(() => {
    const targetPid = query.pid ? +query.pid : null;
    
    // Cek jika PID adalah 110 (Certum Commercial SSL Certificate)
    if (targetPid === 110) {
      setProductNotAvailable(true);
      return;
    }
    
    // Reset state jika PID bukan 110
    if (targetPid !== 110) {
      setProductNotAvailable(false);
    }
  }, [query.pid]);

  // Fetch product hanya sekali saat mount atau query.pid berubah
  useEffect(() => {
    const targetPid = query.pid ? +query.pid : 98;
    
    // Jangan fetch jika produk tidak tersedia (Certum)
    if (productNotAvailable) {
      return;
    }
    
    // Hanya fetch jika PID berbeda dari yang sudah di-fetch
    if (fetchedPidRef.current !== targetPid) {
      // console.log('🔍 [SSL] Fetching product - PID:', targetPid, 'Previous:', fetchedPidRef.current);
      fetchedPidRef.current = targetPid;
      dispatch(getProduct(targetPid));
    }
  }, [dispatch, query.pid, productNotAvailable]); // Hanya depend pada query.pid, bukan current object

  useEffect(() => {
    // Cek jika produk yang di-fetch adalah Certum berdasarkan nama
    if (currentProductStatus !== "loading" && current && current.pid) {
      // Cek jika nama produk mengandung "certum" (case insensitive)
      if (current.name && current.name.toLowerCase().includes('certum')) {
        setProductNotAvailable(true);
        return;
      }
    }
    
    if (currentProductStatus !== "loading" && current && current.pid) {
      // Cegah loop: hanya restore sekali per PID
      if (restoredPidRef.current === current.pid && restoredFromCartRef.current) {
        return;
      }
      
      // console.log('🔍 [SSL] Setting product detail - current:', {
      //   pid: current.pid,
      //   name: current.name,
      //   hasCustomfields: !!current.customfields,
      //   hasCustomfieldArray: !!current?.customfields?.customfield,
      //   customfieldLength: current?.customfields?.customfield?.length || 0,
      //   customfields: current.customfields
      // });
      
      // Cek apakah ada SSL item di cart untuk restore domain
      const existingSSLInCart = productsList.find((item) => item.type === "ssl");
      let restoredCustomfieldvalue = [];
      
      if (existingSSLInCart && existingSSLInCart.customfields && Array.isArray(existingSSLInCart.customfields) && current.customfields?.customfield) {
        // Map customfield dari cart ke customfield baru berdasarkan tipe value
        const currentCustomfields = current.customfields.customfield;
        
        // Cari field-field dari cart berdasarkan tipe value
        const cartDomainField = existingSSLInCart.customfields.find(field => {
          if (!field || !field.value) return false;
          const value = String(field.value).trim();
          if (value.includes('@')) return false; // Skip email
          if (value === 'www' || value === 'tanpa www') return false; // Skip www
          const domainPattern = /^[a-zA-Z0-9][a-zA-Z0-9-_.]*\.[a-zA-Z]{2,}$/;
          return domainPattern.test(value);
        });
        
        const cartEmailField = existingSSLInCart.customfields.find(field => {
          if (!field || !field.value) return false;
          return String(field.value).includes('@');
        });
        
        const cartCSRField = existingSSLInCart.customfields.find(field => {
          if (!field || !field.value) return false;
          const value = String(field.value).trim();
          // CSR biasanya panjang (minimal 100 karakter), tidak email, bukan domain pattern, bukan www
          const isEmail = value.includes('@');
          const isDomain = /^[a-zA-Z0-9][a-zA-Z0-9-_.]*\.[a-zA-Z]{2,}$/.test(value);
          const isWWW = value === 'www' || value === 'tanpa www';
          return value.length > 50 && !isEmail && !isDomain && !isWWW;
        });
        
        const cartWWWField = existingSSLInCart.customfields.find(field => {
          if (!field || !field.value) return false;
          const value = String(field.value).trim();
          return value === 'www' || value === 'tanpa www';
        });
        
        restoredCustomfieldvalue = currentCustomfields.map(cf => {
          let value = '';
          
          // Match berdasarkan name dari current product
          if (cf.name.includes('Domain') || cf.name.includes('FQDN')) {
            value = cartDomainField ? String(cartDomainField.value).trim() : '';
          } else if (cf.name.includes('Email')) {
            value = cartEmailField ? String(cartEmailField.value).trim() : '';
          } else if (cf.name.includes('CSR')) {
            value = cartCSRField ? String(cartCSRField.value).trim() : '';
          } else if (cf.name.includes('www')) {
            value = cartWWWField ? String(cartWWWField.value).trim() : '';
          }
          
          return {
            id: cf.id,
            name: cf.name,
            value: value
          };
        });
        
        // Set domain ke state jika ada
        if (cartDomainField && cartDomainField.value) {
          const domain = String(cartDomainField.value).trim();
          if (domain && isValidDomain(domain)) {
            setFQDN(domain);
            setDomainValue(domain);
            setApproveEmail(cartEmailField ? String(cartEmailField.value).trim() : `admin@${domain}`);
            // console.log('🔍 [SSL] Restored domain from cart:', domain);
          }
        }
        
        // Set www value jika ada
        if (cartWWWField && cartWWWField.value) {
          setWebVal(String(cartWWWField.value).trim());
        }
        
        // Set CSR jika ada
        if (cartCSRField && cartCSRField.value) {
          setCSR(String(cartCSRField.value).trim());
        }
        
        // Mark sebagai sudah di-restore
        restoredFromCartRef.current = true;
        restoredPidRef.current = current.pid;
      }
      
      sslDispatch({
        type: "SET_PRODUCT_DETAIL",
        payload: {
          details: {
            gid: current.gid,
            pid: current.pid,
            name: current.name,
            type: "ssl",
            billingcycle: termin,
            price: +priceByTermin,
            customfields: current.customfields,
            customfieldvalue: restoredCustomfieldvalue.length > 0 ? restoredCustomfieldvalue : [],
          },
          price: current?.pricing?.IDR,
        },
      });
      sslDispatch({ type: "SET_SELECTED_SSL_DROPDOWN", payload: current.pid });
      
      // Jika ada restored customfieldvalue, gunakan itu, jika tidak gunakan customFields
      if (restoredCustomfieldvalue.length > 0) {
        sslDispatch({ type: "ADD_CUSTOMFIELD_VALUE", payload: restoredCustomfieldvalue });
      } else {
      sslDispatch({ type: "ADD_CUSTOMFIELD_VALUE", payload: customFields });
    }
      
      // Reset restored flag jika PID berubah
      if (restoredPidRef.current !== current.pid) {
        restoredFromCartRef.current = false;
        restoredPidRef.current = current.pid;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current?.pid, currentProductStatus, termin, priceByTermin]);

  useEffect(() => {
    dispatch(getProducts(10));
  }, [dispatch]);

  useEffect(() => {
    if (sslProduct && sslProduct.pid) {
      // Cari kategori berdasarkan PID
      const selectedCategory = sslType.find((type) =>
        type.pid_contain.includes(sslProduct.pid)
      );
      
      // console.log('🔍 [SSL] Category detection:', {
      //   sslProductPid: sslProduct.pid,
      //   selectedCategory,
      //   categoryValue: category.value,
      //   selectedSSL
      // });
      
      // Jika kategori ditemukan dan berbeda dengan yang sekarang
      if (selectedCategory && category.value !== selectedCategory.value) {
        const sslItems = sortedProductSSL(selectedCategory.pid_contain);
        
        // console.log('🔍 [SSL] Setting category:', {
        //   categoryValue: selectedCategory.value,
        //   sslItemsCount: sslItems.length,
        //   sslItems: sslItems.map(item => ({ pid: item.pid, name: item.name }))
        // });
        
        // Set kategori dan pastikan produk yang dipilih tetap ada
        setCategory({
          value: selectedCategory.value,
          sslItem: sslItems,
        });
        
        // Jika ada produk yang dipilih, pastikan masih valid untuk kategori baru
        if (selectedSSL !== "none") {
          const productStillValid = sslItems.some(item => item.pid === +selectedSSL);
          if (!productStillValid) {
            // Reset pilihan SSL jika produk tidak valid untuk kategori baru
            // console.log('🔍 [SSL] Product not valid for category, resetting selectedSSL');
            sslDispatch({ type: "SET_SELECTED_SSL_DROPDOWN", payload: "none" });
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sslProduct.pid, sortedProductSSL]);

  useEffect(() => {
    switch (termin) {
      case "triennially":
        setPriceByTermin(sslProduct?.price?.triennially);
        break;
      case "biennially":
        setPriceByTermin(sslProduct?.price?.biennially);
        break;
      case "annually":
        setPriceByTermin(sslProduct?.price?.annually);
        break;
      case "quarterly":
        setPriceByTermin(sslProduct?.price?.quarterly);
        break;
      case "semiannually":
        setPriceByTermin(sslProduct?.price?.semiannually);
        break;
      case "monthly":
        setPriceByTermin(sslProduct?.price?.monthly);
        break;
      default:
        setPriceByTermin(0);
        break;
    }
  }, [termin, dispatch, sslProduct, pid]);

  const setCategoryHandler = (e, pidArr) => {
    setCategory({ value: e.target.value, sslItem: sortedProductSSL(pidArr) });
  };

  const terminHandle = (e) => {
    setTermin(e.target.value);
    setTimeout(() => {
      if (customfieldRef.current) {
      customfieldRef.current.click();
      }
    }, 800);
  };

  const changeSSLHandler = (e) => {
    if (e.target.value === "none") return;
    const selectedPid = +e.target.value;
    const prodFromGroup = products.find((item) => item.pid === selectedPid);
    
    // console.log('🔍 [SSL] changeSSLHandler - Selected SSL:', {
    //   selectedPid,
    //   prodFromGroup,
    //   hasCustomfields: !!prodFromGroup?.customfields,
    //   currentFetchedPid: fetchedPidRef.current
    // });
    
    // Reset restored flag saat user mengganti produk SSL
    if (restoredPidRef.current !== selectedPid) {
      restoredFromCartRef.current = false;
      restoredPidRef.current = null;
    }
    
    // Cek apakah ada SSL item di cart, jika ada ambil domain dari cart
    const existingSSLInCart = productsList.find((item) => item.type === "ssl");
    let domainFromCart = null;
    
    if (existingSSLInCart && existingSSLInCart.customfields && Array.isArray(existingSSLInCart.customfields)) {
      // Cari customfield yang berisi domain (bukan email, bukan www, dll)
      const domainField = existingSSLInCart.customfields.find(field => {
        if (!field || !field.value) return false;
        const value = String(field.value).trim();
        // Skip jika value adalah email (mengandung @)
        if (value.includes('@')) return false;
        // Skip jika value adalah pilihan www
        if (value === 'www' || value === 'tanpa www') return false;
        // Domain harus mengandung titik dan minimal 2 karakter setelah titik
        const domainPattern = /^[a-zA-Z0-9][a-zA-Z0-9-_.]*\.[a-zA-Z]{2,}$/;
        return domainPattern.test(value);
      });
      
      if (domainField) {
        domainFromCart = domainField.value;
        // console.log('🔍 [SSL] Found domain from cart:', domainFromCart);
        
        // Set domain ke state langsung
        setFQDN(domainFromCart);
        setDomainValue(domainFromCart);
        setApproveEmail(`admin@${domainFromCart}`);
      }
    }
    
    // Fetch product detail lengkap dengan customfields hanya jika berbeda dari yang sudah di-fetch
    if (fetchedPidRef.current !== selectedPid) {
      fetchedPidRef.current = selectedPid;
      dispatch(getProduct(selectedPid));
    }
    
    sslDispatch({ type: "SET_SELECTED_SSL_DROPDOWN", payload: e.target.value });
    sslDispatch({
      type: "SET_PRODUCT_DETAIL",
      payload: {
        details: { price: +priceByTermin, billingcycle: termin },
        price: prodFromGroup?.pricing?.IDR,
      },
    });
    dispatch(replaceCurrentProducts(prodFromGroup));
    
    // Customfieldvalue akan di-restore oleh useEffect saat current product ter-load
    // Jadi kita tidak perlu set di sini
    sslDispatch({ type: "ADD_CUSTOMFIELD_VALUE", payload: customFields });
    
    setTimeout(() => {
      if (customfieldRef.current) {
      customfieldRef.current.click();
      }
    }, 800);
  };

  const addToCartHandler = (e) => {
    // Pastikan customfieldvalue adalah array
    const checkSSLItem = Array.isArray(productDetails?.customfieldvalue) 
      ? productDetails.customfieldvalue 
      : [];
    const checkDomain = checkSSLItem.filter((cf) => cf && cf.name && cf.name.includes("Domain"));
    const { value: domain = "" } = checkDomain[0] || {};

    if (!productDetails.name) {
      toast.warn("Silahkan masukkan Produk SSL yang Anda inginkan.", {
        theme: "dark",
        position: "top-center",
      });
      return;
    }

    // Hanya validasi domain jika produk memerlukan domain
    const needsDomain = requiresDomain();
    
    if (needsDomain) {
    if (!domain) {
      toast.warn("Produk ini membutuhkan domain.", {
        theme: "dark",
        position: "top-center",
      });
      return;
    }

    if (!isValidDomain(domain)) {
      toast.error("Domain tidak valid.", {
        theme: "dark",
        position: "top-center",
      });
      return;
      }
    }

    if (status === "idle") {
      // Convert customfieldvalue ke format customfields yang diharapkan oleh CheckoutButton
      // Format: array dengan {id, value} saja (tanpa name)
      // Pastikan customfieldvalue adalah array
      const customfieldvalueArray = Array.isArray(productDetails?.customfieldvalue) 
        ? productDetails.customfieldvalue 
        : [];
      
      // Jika produk tidak memerlukan domain dan tidak ada customfieldvalue, 
      // tetap buat customfields kosong (untuk produk yang tidak memerlukan customfields)
      let customfields = [];
      
      if (customfieldvalueArray.length > 0) {
        customfields = customfieldvalueArray.map((cf) => {
          // Handle jika value adalah array (untuk multi-domain)
          let fieldValue = cf.value;
          if (Array.isArray(fieldValue)) {
            // Jika array, gabungkan dengan koma atau ambil yang pertama
            fieldValue = fieldValue.length > 0 ? fieldValue[0] : '';
          }
          // Pastikan value adalah string
          fieldValue = fieldValue ? String(fieldValue).trim() : '';
          
          return {
            id: cf.id,
            value: fieldValue,
          };
        }).filter((cf) => cf.value !== '' && cf.value !== null && cf.value !== undefined);
      } else if (needsDomain) {
        // Jika produk memerlukan domain tapi tidak ada customfieldvalue, 
        // berarti domain belum diisi (sudah di-handle oleh validasi di atas)
        return;
      }
      // Jika produk tidak memerlukan domain dan tidak ada customfieldvalue, 
      // customfields tetap kosong (diizinkan)

      // Buat productDetails dengan customfields yang sudah di-format
      const productDataToCart = {
        ...productDetails,
        customfields: customfields,
      };

      toast.success("Produk berhasil ditambahkan ke keranjang.", {
        position: "top-center",
      });
      // console.log("productDetails ::", productDataToCart);
      dispatch(addToCart(productDataToCart));
      
      // Reset restored flag setelah addToCart agar bisa restore lagi jika user ganti produk
      restoredFromCartRef.current = false;
    }
  };

  useEffect(() => {
    const checkProduct = productsList.find((list) => list.type === "ssl");
    // Cegah loop: hanya update jika productDetails berubah dan belum di-restore dari cart
    if (productDetails && checkProduct && !customFields && !restoredFromCartRef.current) {
      // Convert customfieldvalue ke format customfields yang diharapkan oleh CheckoutButton
      // Pastikan customfieldvalue adalah array
      const customfieldvalueArray = Array.isArray(productDetails?.customfieldvalue) 
        ? productDetails.customfieldvalue 
        : [];
      
      // Jika ada customfieldvalue, convert ke customfields
      // Jika tidak ada, tetap set customfields kosong (untuk produk tanpa customfields)
      let customfields = [];
      
      if (customfieldvalueArray.length > 0) {
        customfields = customfieldvalueArray.map((cf) => {
          let fieldValue = cf.value;
          if (Array.isArray(fieldValue)) {
            fieldValue = fieldValue.length > 0 ? fieldValue[0] : '';
          }
          fieldValue = fieldValue ? String(fieldValue).trim() : '';
          
          return {
            id: cf.id,
            value: fieldValue,
          };
        }).filter((cf) => cf.value !== '' && cf.value !== null && cf.value !== undefined);
      }
      // Jika customfieldvalue kosong, customfields tetap kosong (diizinkan untuk produk tanpa customfields)

      const productDataToUpdate = {
        ...productDetails,
        customfields: customfields,
      };

      dispatch(changeProductFromCart(productDataToUpdate));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDetails?.pid, productDetails?.customfieldvalue]);

  // useEffect(() => {
  //   if (
  //     currentProduct.status === "idle" &&
  //     sslProduct.productDetails &&
  //     productsList.length > 0
  //   ) {
  //     if (!showPromo && !promoKaosTumbler) {
  //       dispatch(addPromoKaos({ promoKaos: "" }));
  //     } else if (!showPromo && promoKaosTumbler) {
  //       dispatch(addPromoKaos({ promoKaos: "" }));
  //     } else if (showPromo && !promoKaosTumbler) {
  //       dispatch(addPromoKaos({ promoKaos: "" }));
  //     } else {
  //       dispatch(addPromoKaos({ promoKaos: true }));
  //     }
  //   }
  // }, [
  //   currentProduct.status,
  //   dispatch,
  //   productsList.length,
  //   promoKaosTumbler,
  //   showPromo,
  //   sslProduct.productDetails,
  //   termin,
  // ]);

  useEffect(() => {
    if (customFields) {
      setCustomFields(false);
      if (customfieldRef.current) {
      customfieldRef.current.click();
      }
    }
  }, [customFields]);

  // Function dari CustomFieldsInput
  const customField = (e) => {
    e.preventDefault();

    const { csr = '', approval = '', www = '', domain = [] } = e.target.elements;

    let domainEl = Array.from(domain).map((obj) => obj.value);
    if (domainEl.length === 0) domainEl = domain.value;

    const getCFid = current?.customfields?.customfield?.map((cf) => ({
      id: cf.id,
      name: cf.name,
    })) || [];

    const cfpayloadObj = {
      domain: domainEl,
      www: www?.value ?? '',
      csr: csr?.value ?? '',
      approval: approval?.value ?? '',
    };

    const domainCF = getCFid.filter((obj) => obj.name.includes('Domain') || obj.name.includes('FQDN'));

    domainCF.forEach((item, i) => {
      // Pastikan domain disimpan sebagai string, bukan array
      let domainValue = typeof cfpayloadObj.domain === 'string' 
        ? cfpayloadObj.domain 
        : (Array.isArray(cfpayloadObj.domain) && cfpayloadObj.domain.length > 0 
          ? cfpayloadObj.domain[0] 
          : '');
      // Trim dan pastikan tidak kosong
      item.value = String(domainValue).trim();
    });

    const payloadsecondary = getCFid
      .filter((obj) => !obj.name.includes('Domain'))
      .map((obj) => {
        let payloadProcessed = {
          id: obj.id,
          name: obj.name,
        };
        if (obj.name.includes('CSR')) {
          payloadProcessed['value'] = cfpayloadObj.csr;
        }
        if (obj.name.includes('www')) {
          payloadProcessed['value'] = cfpayloadObj.www;
        }
        if (obj.name.includes('Email')) {
          payloadProcessed['value'] = cfpayloadObj.approval;
        }

        return payloadProcessed;
      });

    const combinedPayload = [...domainCF, ...payloadsecondary];
    sslDispatch({ type: 'ADD_CUSTOMFIELD_VALUE', payload: combinedPayload });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    const updatedDataCf = {
      ...current?.customfields,
      [name]: value,
    };

    const customfield = current?.customfields?.customfield ?? [];
    const getCFid = customfield.map((cf) => ({
      id: cf.id,
      name: cf.name,
    }));

    const combinedPayload = getCFid.map((cf) => {
      let payloadProcessed = {
        id: cf.id,
        name: cf.name,
      };

      if (cf.name.includes('Domain') || cf.name.includes('FQDN')) {
        // Untuk Domain/FQDN, simpan sebagai string (bukan array)
        // Ambil value dari updatedDataCf atau dari FQDN state jika ada
        const domainValue = updatedDataCf[cf.name] || FQDN || '';
        payloadProcessed.value = Array.isArray(domainValue) 
          ? (domainValue.length > 0 ? domainValue[0] : '')
          : String(domainValue).trim();
      } else {
        payloadProcessed.value = updatedDataCf[cf.name] || '';
      }

      return payloadProcessed;
    });

    sslDispatch({ type: 'ADD_CUSTOMFIELD_VALUE', payload: combinedPayload });
    setCustomFields(updatedDataCf);
  };

  // Tambahkan fungsi untuk generate email options
  const getEmailOptions = (domain) => {
    if (!domain) return [
      { value: 'admin@yourdomain.xyz', label: 'admin@yourdomain.xyz' },
      { value: 'administrator@yourdomain.xyz', label: 'administrator@yourdomain.xyz' },
      { value: 'postmaster@yourdomain.xyz', label: 'postmaster@yourdomain.xyz' },
      { value: 'webmaster@yourdomain.xyz', label: 'webmaster@yourdomain.xyz' },
      { value: 'hostmaster@yourdomain.xyz', label: 'hostmaster@yourdomain.xyz' }
    ];

    return [
      { value: `admin@${domain}`, label: `admin@${domain}` },
      { value: `administrator@${domain}`, label: `administrator@${domain}` },
      { value: `postmaster@${domain}`, label: `postmaster@${domain}` },
      { value: `webmaster@${domain}`, label: `webmaster@${domain}` },
      { value: `hostmaster@${domain}`, label: `hostmaster@${domain}` }
    ];
  };

  // Tambahkan fungsi validasi domain
  const isValidDomain = (domain) => {
    // Menghapus spasi di awal dan akhir
    const trimmedDomain = domain.trim();
    
    // Check jika domain kosong atau hanya spasi
    if (!trimmedDomain) return false;
    
    // Check jika domain memiliki ekstensi (minimal ada 1 titik)
    if (!trimmedDomain.includes('.')) return false;
    
    // Validasi format domain dengan regex
    const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9-_.]+\.[a-zA-Z]{2,}$/;
    return domainRegex.test(trimmedDomain);
  };

  // Fungsi untuk mengecek apakah produk SSL memerlukan domain
  const requiresDomain = () => {
    // Cek dari current product (yang sudah di-fetch dengan customfields lengkap)
    if (current?.customfields?.customfield && Array.isArray(current.customfields.customfield)) {
      const hasDomainField = current.customfields.customfield.some(cf => 
        cf.name && (cf.name.includes('Domain') || cf.name.includes('FQDN'))
      );
      return hasDomainField;
    }
    
    // Fallback: cek dari productDetails jika current belum ter-load
    if (productDetails?.customfields?.customfield && Array.isArray(productDetails.customfields.customfield)) {
      const hasDomainField = productDetails.customfields.customfield.some(cf => 
        cf.name && (cf.name.includes('Domain') || cf.name.includes('FQDN'))
      );
      return hasDomainField;
    }
    
    // Jika tidak ada customfields, berarti tidak memerlukan domain
    return false;
  };

  // Modifikasi handleDomainChange
  const handleDomainChange = (e) => {
    const domain = e.target.value.trim();
    setFQDN(domain);
    
    // Selalu update customfieldvalue meskipun domain belum valid
    // Ini memastikan value tersimpan saat user mengetik
    const customfield = current?.customfields?.customfield ?? [];
    const domainField = customfield.find(cf => cf.name.includes('Domain') || cf.name.includes('FQDN'));
    
    if (domainField) {
      const getCFid = customfield.map((cf) => ({
        id: cf.id,
        name: cf.name,
      }));
      
      const combinedPayload = getCFid.map((cf) => {
        let payloadProcessed = {
          id: cf.id,
          name: cf.name,
        };
        
        if (cf.name.includes('Domain') || cf.name.includes('FQDN')) {
          payloadProcessed.value = domain; // Simpan domain yang diinput
        } else {
          // Ambil value dari customfieldvalue yang sudah ada
          // Pastikan customfieldvalue adalah array sebelum menggunakan find
          const customfieldvalue = Array.isArray(productDetails?.customfieldvalue) 
            ? productDetails.customfieldvalue 
            : [];
          const existingValue = customfieldvalue.find(cfv => cfv && cfv.id === cf.id);
          payloadProcessed.value = existingValue?.value || '';
        }
        
        return payloadProcessed;
      });
      
      sslDispatch({ type: 'ADD_CUSTOMFIELD_VALUE', payload: combinedPayload });
    }
    
    if (!isValidDomain(domain)) {
      // Tambahkan class invalid ke input
      e.target.classList.add('is-invalid');
      // Jika domain tidak valid, jangan update email options
      return;
    }
    
    // Jika valid, hapus class invalid dan update email options
    e.target.classList.remove('is-invalid');
    setDomainValue(domain);
    setApproveEmail(`admin@${domain}`);
    handleInputChange(e);
  };

  return (
    <MainLayouts summary={false}>
      <CardWrapper title="Order SSL">
        {/* Tampilkan pesan error jika produk tidak tersedia (Certum) */}
        {productNotAvailable ? (
          <div className="mb-4">
            <Alert 
              variant="danger" 
              className="rounded-3 border border-danger border-opacity-50 shadow-sm alert-product-unavailable"
            >
              <h5 className="alert-heading mb-3 fw-bold alert-heading-text d-flex align-items-center">
                <FontAwesomeIcon 
                  icon={faExclamationTriangle} 
                  className="fs-5 alert-icon-danger me-2" 
                />
                <span>Produk Tidak Tersedia</span>
              </h5>
              <div>
                <p className="mb-2 alert-body-text">
                  Maaf, produk SSL yang Anda cari <strong className="alert-strong-text">Certum Commercial SSL Certificate</strong> tidak tersedia untuk pemesanan.
                </p>
                <p className="mb-3 small alert-subtitle-text">
                  Silakan pilih produk SSL lainnya atau kunjungi halaman SSL Qwords untuk melihat pilihan produk SSL yang terbaik untuk Anda.
                </p>
                <div className="d-flex gap-2">
                  <Button
                    variant="danger"
                    size="sm"
                    className="d-flex align-items-center"
                    onClick={() => window.open('https://www.qwords.com/secured-sockets-layer-certificate/', '_blank')}
                  >
                    <span>Lihat Produk SSL Lainnya</span>
                    <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                  </Button>
                </div>
              </div>
            </Alert>
          </div>
        ) : (
          <>
            <div className="mb-3">
              <label className="form-label fw-bold">Pilih Kategori SSL:</label>
              <div className="mt-2">
                {sslType.map((item) => (
                  <div className="form-check mb-2" key={item.id}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="ssltype"
                      value={item.value}
                      id={item.value}
                      checked={item.value === category?.value}
                      onChange={(e) => setCategoryHandler(e, item.pid_contain)}
                    />
                    <label className="form-check-label" htmlFor={item.value}>
                      {item.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <hr className="my-4" />

            <div className="row">
              <div className="col-12 mb-3">
            {status === "loading" && (
              <Placeholder
                as="h3"
                animation="glow"
                className="d-flex justify-content-between"
              >
                <Placeholder xs={5} bg="danger" />
                <Placeholder xs={2} bg="dark" />
              </Placeholder>
            )}
            {status === "idle" && (
              <>
                <h5 className="text-qw-primary fw-bold mb-2">
                  {productDetails?.name}
                </h5>
                {priceByTermin && (
                  <div className="text-end">
                    <label className="text-muted small d-block mb-1">Harga:</label>
                    <div className="fw-bold fs-5">{formatIDR(priceByTermin ?? 0)}</div>
                  </div>
                )}
              </>
            )}
          </div>

          {status === "loading" && (
            <div className="text-center py-4">
              <Spinner />
            </div>
          )}

          {status !== "loading" && (
            <>
              <div className="col-12 mb-3">
                <label htmlFor="ssl" className="form-label fw-bold">
                  Pilih SSL<span className="text-danger"> *</span>
                </label>
                <select
                  name="ssl"
                  id="ssl"
                  className="form-select"
                  onChange={changeSSLHandler}
                  value={selectedSSL}
                >
                  <option value="none">Tipe SSL</option>
                  {category.sslItem?.filter(item => !item.name.toLowerCase().includes('certum')).map((item) => (
                    <option value={item.pid} key={item.pid}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 mb-3">
                <BillingCycleOptions
                  termin={termin}
                  terminHandle={terminHandle}
                  productsItem={sslProduct}
                />
              </div>

              {/* Form dari CustomFieldsInput */}
              {/* Debug logging */}
              {(() => {
                // console.log('🔍 [SSL] Form Debug:', {
                //   currentProductStatus,
                //   hasCurrent: !!current,
                //   hasCustomfields: !!current?.customfields,
                //   hasCustomfieldArray: !!current?.customfields?.customfield,
                //   customfieldLength: current?.customfields?.customfield?.length || 0,
                //   currentPid: current?.pid,
                //   selectedSSL,
                //   productDetailsPid: productDetails?.pid,
                //   status,
                //   selectedSSLValue: selectedSSL !== "none"
                // });
                return null;
              })()}

              {/* Pastikan form muncul jika produk SSL sudah dipilih */}
              {selectedSSL !== "none" ? (
              <form onSubmit={customField} action="POST" className="w-100">
                <div className="row g-3">
                    {currentProductStatus === "loading" ? (
                      <div className="col-12">
                        <div className="text-center py-3">
                          <Spinner size="sm" />
                          <div className="mt-2 small text-muted">Memuat form...</div>
                        </div>
                      </div>
                    ) : current?.customfields?.customfield && Array.isArray(current.customfields.customfield) && current.customfields.customfield.length > 0 ? (
                      current.customfields.customfield.map((item) => (
                    <div className="col-12 col-md-6" key={item.id}>
                      <label htmlFor={'input_' + item.id} className="form-label fw-bold">
                        {item.name}
                        {item.required ? <span className="text-danger"> *</span> : ''}
                        {!item.required && item.name.includes('CSR') ? <span className="text-muted"> (Opsional)</span> : ''}
                      </label>
                      {(item.name.includes('FQDN') || item.name.includes('Domain')) && (
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            id={'input_' + item.id}
                            placeholder="Masukkan Domain (FQDN) Anda"
                            name="domain"
                            value={FQDN}
                            onChange={handleDomainChange}
                            required
                          />
                          <div className="invalid-feedback">
                            Domain tidak valid. Pastikan domain memiliki format yang benar (contoh: domain.com)
                          </div>
                        </div>
                      )}
                      {item.name.includes('CSR') && (
                        <input
                          type="text"
                          className="form-control"
                          id={'input_' + item.id}
                          placeholder="Masukkan CSR Anda (opsional)"
                          defaultValue={CSR}
                          onChange={(e) => {
                            setCSR(e.target.value);
                            handleInputChange(e);
                          }}
                          name="csr"
                        />
                      )}
                      {item.name.includes('Email') && (
                        <select
                          name="approval"
                          className="form-select"
                          id={'input_' + item.id}
                          value={approveEmail}
                          onChange={(e) => {
                            setApproveEmail(e.target.value);
                            handleInputChange(e);
                          }}
                        >
                          {getEmailOptions(domainValue).map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      )}
                      {item.name.includes('www') && (
                        <div className="d-flex gap-4 mt-2">
                          <div className="form-check">
                            <input
                              type="radio"
                              name="www"
                              value="tanpa www"
                              className="form-check-input"
                              id="www-none"
                              checked={webVal === 'tanpa www'}
                              onChange={(e) => {
                                setWebVal(e.target.value);
                                handleInputChange(e);
                              }}
                            />
                            <label htmlFor="www-none" className="form-check-label">Tanpa www</label>
                          </div>
                          <div className="form-check">
                            <input
                              type="radio"
                              name="www"
                              value="www"
                              className="form-check-input"
                              id="www-with"
                              checked={webVal === 'www'}
                              onChange={(e) => {
                                setWebVal(e.target.value);
                                handleInputChange(e);
                              }}
                            />
                            <label htmlFor="www-with" className="form-check-label">www</label>
                          </div>
                        </div>
                      )}
                    </div>
                    ))
                    ) : (
                      // Jika produk tidak memiliki customfields, tidak perlu menampilkan pesan apapun
                      // Produk SSL tanpa customfields tetap bisa ditambahkan ke cart
                      null
                    )}
                </div>
                <button className="btn btn-success d-none" ref={customfieldRef} type="submit">
                  Test
                </button>
              </form>
              ) : (
                <div className="col-12">
                  <div className="alert alert-info">
                    <i className="fas fa-info-circle me-2"></i>
                    Silakan pilih produk SSL terlebih dahulu.
                  </div>
                </div>
              )}
            </>
          )}
        </div>
            <AddToCartButton
              onClick={addToCartHandler}
              onMouseEnter={() => {
                if (customfieldRef.current) {
                  customfieldRef.current.click();
                }
              }}
            />
          </>
        )}
      </CardWrapper>
    </MainLayouts>
  );
};

export default OrderSSL;
